<template>
  <div class="pt-6">
    <v-row no-gutters>
        <v-col class="ml-4 font18 bold headline2">โปรโมชั่น</v-col>
        <v-col class="text-end icon1 pr-8 bold font14 link" @click="$router.push('blog')">ดูทั้งหมด ></v-col>
    </v-row>
    <v-row v-if="loading && items.length === 0">
      <v-col cols="12"  align="center">
     <v-progress-circular
      indeterminate
      color="primary"
    ></v-progress-circular>
      </v-col>
    </v-row>
    <v-row v-if="items.length === 0 && !loading" align="center" justify="center">
      <v-col cols="12" align="center">
       ไม่มีข้อมูล
      </v-col>
    </v-row>
    <v-sheet class="mx-auto" max-width="1600" v-if="items.length > 0">
        <v-slide-group>
            <v-slide-item v-for="(item,i) in items" :key="i">
                <v-card
                class="ma-4"
                width="270"
                >
                  <v-img :src="item.blogPicture" height="176px" style=" width: 100%; height: auto;" class="link" @click="$router.push(`/blog/detail/${item.id}`)">
                  </v-img>
                  <!-- <v-img :src="item.pictureUrl" height="176px" class="link" v-if="member === null"></v-img> -->
                  <v-card-title class="font16 bold headline2">
                      <v-row style="padding-bottom: 0px">
                          <v-col  class="pb-0" @click="$router.push(`/blog/detail/${item.id}`)">{{item.blogName}}</v-col>
                      </v-row>
                      <v-row>
                        <v-col class="pa-0 pr-3" style="text-align: end;">
                      <a v-if="item.output === 'เว็บไซต์'" :href="item.blogLink" class="font14 mb-0 icon1" > อ่านเพิ่มเติม >> </a>
                      <p  v-if="item.output === 'รายละเอียด'  " @click="$router.push(`/blog/detail/${item.id}`)" class="font14 mb-0 text-end icon1">
                        อ่านเพิ่มเติม >>
                      </p>
                      </v-col>
                      </v-row>
                  </v-card-title>
                </v-card>
            </v-slide-item>
        </v-slide-group>
    </v-sheet>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
export default {
  name: 'BlogHome',
  data () {
    return {
      items: [],
      member: null,
      shopId: null,
      loading: true,
      profile: []
    }
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    window.scrollTo(0, 0)
    this.member = this.GET_MEMBERINFO()
    this.profile = this.getLiffProfile()
    this.shopId = this.GET_SHOPID()
    await this.getBlog()
    window.scrollTo(0, document.body.scrollHeight)
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID']),

    async getBlog () {
      this.items = []
      const result = await axios.get(this.DNS_IP + `/blog/get?RECORD_STATUS=N&shopId=${this.shopId}`, { headers: {lineUserId: this.profile.userId, shopId: this.shopId} })
      // const result = await this.callBeTaskAPI(
      //   'get',
      //   `/blog/get?RECORD_STATUS=N&shopId=${this.session.shopId}`
      // )
      if (Array.isArray(result.data)) {
        this.items = result.data
        // setTimeout(() => { this.items = result }, 100)
      } else {
        this.loading = false
        this.items = []
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogHome.vue